import React from "react";
import { motion } from "framer-motion";

interface ServiceTabsProps {
  activeTab: "services" | "partners";
  onChange: (tab: "services" | "partners") => void;
}

const ServiceTabs: React.FC<ServiceTabsProps> = ({ activeTab, onChange }) => {
  const tabs = [
    { key: "services", label: "Services" },
    { key: "partners", label: "Service Partners" },
  ] as const;

  return (
    <div className="bg-white rounded-xl overflow-hidden mb-2">
      <div className="flex gap-6 p-3">
        {tabs.map(({ key, label }) => {
          const isActive = activeTab === key;

          return (
            <motion.button
              key={key}
              onClick={() => onChange(key)}
              className={`
                relative px-4 py-1 font-semibold text-sm
                ${
                  isActive
                    ? "text-[#0077C0]"
                    : "text-gray-600 hover:text-gray-900"
                }
              `}
              whileHover={{ scale: isActive ? 1 : 1.05 }}
              whileTap={{ scale: 0.97 }}
            >
              {label}

              {isActive && (
                <motion.div
                  layoutId="serviceTabIndicator"
                  className="absolute -bottom-1 left-2 right-2 h-[2px] bg-[#0077C0] rounded-full"
                  transition={{
                    type: "spring",
                    bounce: 0.25,
                    duration: 0.5,
                  }}
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default ServiceTabs;
